"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9528,7364],{

/***/ 19528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63750);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_apiClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77364);
/* harmony import */ var react_icons_bi__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47516);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _context_useStore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80094);










var MoreFilters = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8427), __webpack_require__.e(5286)]).then(__webpack_require__.bind(__webpack_require__, 75286));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75286)
            ];
        }
    },
    suspense: true
});
var PriceFilters = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8427), __webpack_require__.e(1054)]).then(__webpack_require__.bind(__webpack_require__, 1054));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1054)
            ];
        }
    },
    suspense: true
});
var TypeFilters = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8427), __webpack_require__.e(8012)]).then(__webpack_require__.bind(__webpack_require__, 88012));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88012)
            ];
        }
    },
    suspense: true
});
var StylesFilters = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8427), __webpack_require__.e(8645)]).then(__webpack_require__.bind(__webpack_require__, 18645));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(18645)
            ];
        }
    },
    suspense: true
});
var ListingAlert = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 6953).then(__webpack_require__.bind(__webpack_require__, 26953));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26953)
            ];
        }
    },
    suspense: true
});
var Filters = function(param) {
    var queries = param.queries, query = param.query;
    var push = queries.push;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), show = ref[0], setShow = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var auth = (0,_context_useStore__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().auth;
    var track = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(city) {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _utils_apiClient__WEBPACK_IMPORTED_MODULE_3__/* .apiClient.post */ .x.post("/api/v1/track/page", {
                                page: city
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(city) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (auth.login) {
            if (auth.role === "user") {
                track(query.city || "");
            }
        }
    }, [
        auth.login,
        query.city,
        auth.role,
        track
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex gap-4 overflow-x-auto px-5 md:px-2 no-scrollbar",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
                        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "Loading..."
                            })
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StylesFilters, {
                            push: push,
                            query: query
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
                        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "Loading..."
                            })
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TypeFilters, {
                            push: push,
                            query: query
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
                        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "Loading..."
                            })
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PriceFilters, {
                            push: push,
                            query: query
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
                        fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "Loading..."
                            })
                        }),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MoreFilters, {
                            push: push,
                            query: query
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        className: "flex gap-2 min-w-fit",
                        onClick: function() {
                            if (router.query.city) {
                                router.push("/city/" + router.query.city);
                            } else if (router.query.area) {
                                router.push("/area/" + router.query.area);
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bi__WEBPACK_IMPORTED_MODULE_8__/* .BiRefresh */ .t5J, {
                                fontSize: 22
                            }),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: "Clear Filter"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        onClick: function() {
                            return setShow(function(pre) {
                                return !pre;
                            });
                        },
                        className: "flex gap-2 justify-center items-center whitespace-nowrap",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_9__/* .BsBellFill */ .JdD, {}),
                            " Listing Alert"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
                fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListingAlert, {
                    visible: show,
                    onClose: function() {
                        return setShow(false);
                    }
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Filters);


/***/ }),

/***/ 77364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ apiClient; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87066);

var apiClient = axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].create */ .Z.create({
    baseURL: "https://api.bungalowfinder.ca"
});
// export const apiClient = axios.create({
//   baseURL: "http://127.0.0.1:2000",
// });
apiClient.interceptors.request.use(function(config) {
    var token = localStorage.getItem("token");
    if (!token) return config;
    if (config.headers) {
        config.headers["Authorization"] = "Bearer ".concat(token);
    }
    return config;
}, function(error) {
    return Promise.reject(error);
});
apiClient.interceptors.response.use(function(res) {
    var _res = {
        ok: true,
        data: res.data,
        status: res.status
    };
    return _res;
}, function(error) {
    var res = undefined;
    if (error.response) {
        var _message = [];
        _message.push(error.response.data.message);
        res = {
            status: error.response.status,
            error: "SERVER",
            message: _message,
            data: error.response.data,
            ok: false
        };
        if (res.status === 401) {
            localStorage.removeItem("token");
            window.dispatchEvent(new CustomEvent("unauth"));
        }
        return Promise.resolve(res);
    }
    if (error.request) {
        res = {
            status: 500,
            data: error.request,
            error: "CLIENT",
            message: error.message,
            ok: false
        };
        return Promise.resolve(res);
    }
    res = {
        status: 500,
        data: {},
        ok: false,
        error: "ANY",
        message: [
            "Internal Server Error"
        ]
    };
    return Promise.resolve(res);
});


/***/ })

}]);